/******/ (() => { // webpackBootstrap
/* eslint-disable */
class ProductSwatch extends HTMLElement {
  constructor() {
    super();

    /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
    this.onSwatchChangeBound = this.onSwatchChange.bind(this);
    this.onColorSwatchMouseEnterBound = this.onColorSwatchMouseEnter.bind(this);
    this.onSwatchMouseLeaveBound = this.onSwatchMouseLeave.bind(this);
  }

  
  connectedCallback() {
    this.colorLabel = this.querySelector('[data-color-swatch-name]');
    this.colorLabelState = this.querySelector('[data-color-swatch-state]');
    this.soldOutString = this.getAttribute('data-swatch-sold-out-string');
    this.colorSwatches = this.querySelectorAll('.swatch-element.color');
    this.sectionId = this.getAttribute('data-section-id');
    this.setEventListeners();
    this.setColorLabelState();
  }

  setEventListeners() {
    /* ===== Attach the event listeners to the DOM elements ===== */
    this.colorSwatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', this.onColorSwatchMouseEnterBound);
      swatch.addEventListener('mouseleave', this.onSwatchMouseLeaveBound);
    });

    this.addEventListener('change', this.onSwatchChangeBound);
  }

  setColorLabelState() {
    /* ===== Set the color label state based on the active swatch ===== */
    const activeSwatch = this.querySelector('.swatch-element.color.active');
    if (!activeSwatch) return;

    const activeSwatchAvailable = activeSwatch.getAttribute('data-swatch-option-available');
    if (!this.soldOutString || !this.colorLabelState) return;

    // Set color label state (sold out or not)
    this.updateColorLabelState(activeSwatchAvailable);
  }

  updateColorLabelState(available) {
    /* ===== Set the color label state (sold out or not) ===== */
    if (this.colorLabelState) {
      this.colorLabelState.innerText = available === 'false' ? `(${this.soldOutString})` : '';
    }
  }
  
  
  
  onSwatchChange(event) {
    const input = event.target;
    const currentVariant = this.getVariantData(input.id);
    const productUrl = input.getAttribute('data-product-url');
    const productFetchUrl = input.getAttribute('data-product-fetch-url');
    const isCombinedListing = input.getAttribute('data-is-combined-listing') === 'true';
    const isavailable = input.getAttribute('data-available');
    var allchecks = '';
    $('input[type="radio"]:checked').each(function(){
      if(allchecks == ''){
        allchecks = allchecks+""+$(this).val();
      }else{
        allchecks = allchecks+" / "+$(this).val();        
      }
      
    });
    
    //document.querySelector('span.selectedDetails').innerText = allchecks;
    if(isavailable == 'unavailable'){
      //document.querySelector('span.selectedDetails').innerText = allchecks;
      document.querySelector('span.main_atc').innerText = 'Unavailable'; document.querySelector('button.product--add-to-cart-button').setAttribute("disabled","disabled");
      setTimeout(function(){  document.querySelector('span.main_atc').innerText = 'Unavailable'; document.querySelector('button.product--add-to-cart-button').setAttribute("disabled","disabled") }, 200);
      }
    jQuery(document).ready(function(){
      $('button[name="plus"], button[name="minus"]').on('click', function(){
        var qtyn = $('input[name="quantity-js"]').val();
        var qtya = parseInt($('div#instock_v').attr('data-qty'));
        var qtyr = qtyn-qtya;
        if(qtyn > qtya){
          $('div#instock_v span#selectedStock span').text(qtya+' in stock, '+qtyr+' on order. Your order will be dispatched when all items are in stock');
          $('div#instock_v').removeClass('variant_available').addClass('variant_unavailable');
        }else{
          $('div#instock_v span#selectedStock span').text('In Stock - Ready For Despatch');
          $('div#instock_v').removeClass('variant_unavailable').addClass('variant_available');
        }
      });
      $('input[name="quantity-js"]').on('keyup',function(){
        var qtyn = $(this).val();
        var qtya = parseInt($('div#instock_v').attr('data-qty'));
        var qtyr = qtyn-qtya;
        if(qtyn > qtya){
          $('div#instock_v span#selectedStock span').text(qtya+' in stock, '+qtyr+' on order. Your order will be dispatched when all items are in stock');
          $('div#instock_v').removeClass('variant_available').addClass('variant_unavailable');
        }else{
          $('div#instock_v span#selectedStock span').text('In Stock - Ready For Despatch');
          $('div#instock_v').removeClass('variant_unavailable').addClass('variant_available');
        }
      });
    });
    // Change variant availabilty message
    var element = document.getElementById("instock_v");
    var element2 = document.getElementById("outstock_v");
    var element3 = document.getElementById("unavailable_v");
    if(currentVariant === null){
      console.log(allchecks);
      setTimeout(function(){  
      document.getElementsByClassName("selectedDetails")[1].innerText = allchecks;
      }, 200);
      //document.querySelector('span#selectedDetails').innerText = allchecks;
      if(element){
        element.classList.add("hidden");
      }
      if(element2){
        element2.classList.add("hidden");
      }
      if(element3){
        element3.classList.remove("hidden");
      }
    }
    if(currentVariant != null){
      if(element){
        element.classList.remove("hidden");
      }
      if(element2){
        element2.classList.remove("hidden");
      }
      if(element3){
        element3.classList.add("hidden");
      }
      
    }
    
    // $('button[name="plus"], button[name="minus"]').on('click', function(){
    // var qtyn = $('input[name="quantity-js"]').val();
    // var qtya = $('div.variant_availability').attr('data-qty');
    // console.log(qtyn+' - '+qtya);
    // });
    function findIndexByValue(jsonArray, key, value) {
      return jsonArray.findIndex(obj => obj[key] === value);
    }
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      fetch("https://sportingbilly.com/cdn/shop/t/5/assets/sporting_billy_suppliers.json", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const inputElement = document.getElementById('product_supplier').value;
          if(inputElement != ''){
            var dataset = JSON.parse(result);
            const foundKey = findIndexByValue(dataset, "SUPLIER", inputElement);
            //console.log(foundKey);
            if (foundKey && document.getElementById('supplier_days') && foundKey != -1) {
              document.getElementById('supplier_days').innerText = dataset[foundKey]['Days'];
            } else if (foundKey && document.getElementById('supplier_days')  && foundKey == -1) {
              document.getElementById('supplier_days').innerText = '7';
            }else{
              //document.getElementById('supplier_days').innerText = '7';
            }
          }else{
            document.getElementById('supplier_days').innerText = '7';
          }
        }
     )
        .catch((error) => console.error(error));
    this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);
  }

  emitVariantChangeEvent(variant, productFetchUrl, productUrl, isCombinedListing = false) {
    /* ===== Emit the variant:change event ===== */
    eventBus.emit('variant:change', {
      sectionId: this.sectionId,
      variant: variant,
      fetchURL: productFetchUrl,
      productURL: productUrl,
      isCombinedListing: isCombinedListing
    });
  }

  onColorSwatchMouseEnter(event) {
    /* ===== Update the color label on mouse enter ===== */
    this.updateColorLabel(event.currentTarget);
    
    // Add sibling hover active class
    const activeSwatch = this.querySelector('.swatch-element.color.active');
    if (activeSwatch && !event.currentTarget.classList.contains('active')) activeSwatch.classList.add('sibling-hover-active');
  }

  onSwatchMouseLeave() {
    /* ===== Reset the color label on mouse leave ===== */
    // Remove sibling hover active class
    const siblingHoverActiveSwatch = this.querySelector('.swatch-element.sibling-hover-active');
    if (siblingHoverActiveSwatch) siblingHoverActiveSwatch.classList.remove('sibling-hover-active');

    // Reset color label
    this.resetColorLabel();
  }

  updateColorLabel = (swatch) => {
    /* ===== Update the color label based on the swatch value ===== */
    if (!swatch) return;
    const label = swatch.getAttribute('data-value');
    const swatchAvailable = swatch.getAttribute('data-swatch-option-available');

    if (!label || !this.colorLabel) return;
    // Set color label text
    this.colorLabel.textContent = label;
    // Set color label state (sold out or not)
    this.updateColorLabelState(swatchAvailable);
  }

  resetColorLabel = () => {
    /* ===== Reset the color label to the active swatch value ===== */
    const activeSwatch = this.querySelector('.swatch-element.color.active');
    if (!activeSwatch || !this.colorLabel) return;

    const activeSwatchValue = activeSwatch.getAttribute('data-value');
    const swatchAvailable = activeSwatch.getAttribute('data-swatch-option-available');
    if (!activeSwatchValue) return;

    // Reset color label text
    this.colorLabel.textContent = activeSwatchValue;
    // Reset color label state (sold out or not)
    this.updateColorLabelState(swatchAvailable);
  }	

  removeEventListeners() {
    /* ===== Remove the event listeners from the DOM elements ===== */
    this.colorSwatches.forEach(swatch => {
      swatch.removeEventListener('mouseenter', this.onColorSwatchMouseEnterBound);
      swatch.removeEventListener('mouseleave', this.onSwatchMouseLeaveBound);
    });

    this.removeEventListener('change', this.onSwatchChangeBound);
  }

  getVariantData(inputId) {
    return JSON.parse(this.getVariantDataElement(inputId).textContent);
  }

  getVariantDataElement(inputId) {
    return this.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
  }

  disconnectedCallback() {
    /* ===== Remove the event listeners when the element is removed from the DOM ===== */
    this.removeEventListeners();
  }
}

if (!window.customElements.get('product-swatch')) {
  window.customElements.define('product-swatch', ProductSwatch);
}

/******/ })()
;